import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { EditFormComponent } from 'app/form/edit-form/edit-form.component';
import { FormInstances } from 'app/form/form-instances.enum';

import { FormModalAction } from './form-modal-action.model';
import { FormModalResult } from './form-modal-result';

@Component({
  selector: 'cc-template-form-add',
  template: '',
})
export class TemplateFormAddComponent implements OnInit {
  public modalReference: NgbModalRef;

  teamId: string;
  templateId: string;

  constructor(
    private readonly modal: NgbModal,
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
  ) {}

  async ngOnInit() {
    this.templateId = this.activatedRoute.snapshot.paramMap.get('templateId');
    this.teamId = this.activatedRoute.snapshot.queryParamMap?.get('teamId');
    let dismissGuard;
    this.modalReference = this.modal.open(EditFormComponent, {
      backdrop: 'static',
      windowClass: 'form-modal full-modal',
      container: '.form-modal-container',
      beforeDismiss: () => dismissGuard(),
    });
    dismissGuard = () => this.modalReference.componentInstance.beforeDismiss();
    this.modalReference.componentInstance.templateId = this.templateId;
    this.modalReference.componentInstance.formInstance = FormInstances.AddForm;

    return this.modalReference.result
      .then((result) => this.closeActions[result.reason](result))
      .catch((result?) => {
        if (result?.reason) {
          return this.closeActions[result?.reason](result);
        }
        return this.closeActions[FormModalAction.Close]();
      });
  }

  get closeActions() {
    return {
      [FormModalAction.Close]: () => this.navigateTo({ opts: { state: { reload: false } } }),
      [FormModalAction.Add]: (result: FormModalResult) =>
        this.navigateTo({ opts: { state: { ...result, reload: true } } }),
      [FormModalAction.Sign]: (result: FormModalResult) =>
        this.navigateTo({
          route: ['..', result.formId],
          opts: { queryParams: { ...result, reload: true } },
        }),
      [FormModalAction.Clone]: (result: FormModalResult) =>
        this.navigateTo({ route: ['..', result.formId], opts: { queryParams: { ...result, reload: true } } }),
      [FormModalAction.Customise]: () =>
        this.navigateTo({
          route: ['/', 'apps', 'teams', this.teamId, 'grid', this.templateId],
          opts: { queryParams: { navigateOnSignUpToFormModal: true, teamId: this.teamId } },
        }),
    };
  }

  navigateTo({ route = ['..'], opts = {} }) {
    return this.router.navigate(route, {
      relativeTo: this.activatedRoute,
      queryParamsHandling: 'merge',
      ...opts,
    });
  }
}
